import { first, map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { SignatureSettings } from "@cs-ts/signature-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class SignatureDef extends BaseElementDef<SignatureSettings, FormDefinitionItem<SignatureSettings>, FormItem> {
    declare isSignature: true;
    declare isCustomViewType: true;
    declare isSigned: boolean;
    declare isSigned$: BehaviorSubject<boolean>;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<SignatureSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.isSignature = true;
        this.isCustomViewType = true;
        this.isSigned = this.isSigned || false;
        this.isSigned$ = this.isSigned$ || new BehaviorSubject(this.isSigned);
        this.typeName = "MI.Common.DynamicForms.Models.DFSignature"; // TODO - not hardcoded?
    }

    setData(data: FormItem | null, excludeChildren?: boolean) {
        super.setData(data, excludeChildren);
        if (data == null) {
            return;
        }
        this.setKey(data, "isSigned");
    }

    visible() {
        return this.isSigned$.pipe(first()).toPromise();
    }

    viewTypes() {
        return [this.definition.settings.label, `${this.definition.settings.label} (Certification)`];
    }

    hasCustomConfirmComponent(adminPreview: boolean) {
        return adminPreview;
    }

    async getCustomConfirmComponent(adminPreview: boolean) {
        const func = (await import(/* webpackChunkName: "PageAdmin" */ "./SignatureDef.Admin")).getCustomConfirmComponent;
        return await func.apply(this, []);
    }

    requireUserVerification() {
        const rUV = this.definition.settings.requireUserVerification;
        return rUV == null ? true : rUV;
    }

    shouldSkipConfirm() {
        return this.isSigned ? null : false;
    }

    shouldSkipConfirm$() {
        return this.isSigned$.pipe(map(i => (i ? null : false)));
    }

    hasCustomSubmitText$() {
        return this.isSigned$.pipe(map(i => !i));
    }

    submitText$() {
        return this.isSigned$.pipe(map(i => (!i ? "Sign" : null)));
    }
}

export function isSignatureDef(i: BaseElementDefBase): i is SignatureDef {
    //@ts-ignore
    return i.isSignature;
}
